import React from 'react';
import { makeStyles, useTheme, Link, Typography } from '@material-ui/core';
import { TaxiCompanyList } from '../../../../../services/taxi/GetDirectionAndFare/models/getFareSamplesParams';
import { useSelector } from 'react-redux';
import { State } from '../../../../../reducers';
import { isEmail } from '../../../../../utils/regExpUtils';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
    fontSize: '0.875rem',
    marginTop: '10px',
  },
}));

interface Props {
  company: TaxiCompanyList
}

/** 空港送迎タクシー予約画面の問い合わせ先のコンポーネント。 */
export const Contact: React.FC<Props> = (props: Props) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const { t } = useTranslation();
  const taxiCompanyConfigurations = useSelector((state: State) => state.general.taxiCompanyConfigurations);
  if(!taxiCompanyConfigurations) {
    return null;
  }
  const taxiCompanyConfiguration = taxiCompanyConfigurations[props.company] || taxiCompanyConfigurations[TaxiCompanyList.limoTaxi];
  const contact = taxiCompanyConfiguration.contact;

  return (
    <Typography className={classes.root} data-cy="booking_taxi_contact_area">
      {/** 問い合わせ先の表記は各社共通なので個別には表記しない */}
      {t('taxi:contact')}<br/>
      { contact.messages.map((message: string, idx: number)=>{
        const isEmailStr = isEmail(message);
        // Email文字列の場合にはリンクにする
        if(contact.isLinkMailAddress === 'true' && isEmailStr) {
          return (
            <span key={idx}>
              <Link href={`mailto:${message}`}>
                {message}
              </Link>
              <br/>
            </span>
          )
        }
        // URL文字列を含む場合にはURL部分をリンクにする
        const urlRegex = /(https?:\/\/[^\s]+)/;
        if(urlRegex.test(message)) {
          const parts = message.split(urlRegex);
          return (
            <span key={idx}>
              {parts.map((part, partIdx) =>
                urlRegex.test(part)
                  ? <Link key={partIdx} href={part} target="_blank" rel="noopener noreferrer">{part}</Link>
                  : part
              )}
              <br/>
            </span>
          )
        }
        return (
          <span key={idx}>
            {message}<br/>
          </span>
        )
      })}
    </Typography>
  );
}

export default Contact;
